{ fetchJson } = require './index'
{ doFlash } = require './flash'
{ serializeForQueryString } = require '../lib/urlHelper'

AUTHENTICATING_STUDENT = 'AUTHENTICATING_STUDENT'
AUTHENTICATED_STUDENT = 'AUTHENTICATED_STUDENT'

LOG_STUDENT_OUT = 'LOG_STUDENT_OUT'

FAILED_CREATE_MESSAGE = 'Failed to create a new student'
SUCCEEDED_CREATE_MESSAGE = 'Student created'
CREATED_STUDENT = 'CREATED_STUDENT'
CREATING_STUDENT = 'CREATING_STUDENT'

FAILED_DELETE_MESSAGE = 'Deletion failed'
SUCCEEDED_DELETE_MESSAGE = 'Student deleted'
DELETED_STUDENT = 'DELETED_STUDENT'
DELETING_STUDENT = 'DELETING_STUDENT'

FAILED_FETCH_SINGLE_MESSAGE = 'Failed to retrieve the student data from the server'
FETCHED_STUDENT = 'FETCHED_STUDENT'
FETCHING_STUDENT = 'FETCHING_STUDENT'

FAILED_FETCH_MESSAGE = 'Failed to retrieve the list of students from the server'
FETCHED_STUDENTS = 'FETCHED_STUDENTS'
FETCHING_STUDENTS = 'FETCHING_STUDENTS'

IMPORTING_STUDENTS = 'IMPORTING_STUDENTS'
IMPORTED_STUDENTS = 'IMPORTED_STUDENTS'

FAILED_REMOVING_STUDENT = 'Could not remove that student from the classroom'
SUCCEEDED_REMOVAL_MESSAGE = 'Removed student from classroom'
REMOVED_STUDENT_FROM_CLASSROOM = 'REMOVED_STUDENT_FROM_CLASSROOM'
REMOVING_STUDENT_FROM_CLASSROOM = 'REMOVING_STUDENT_FROM_CLASSROOM'

FAILED_UPDATE_MESSAGE = 'Update failed'
SUCCEEDED_UPDATE_MESSAGE = 'Student updated'
UPDATED_STUDENT = 'UPDATED_STUDENT'
UPDATING_STUDENT = 'UPDATING_STUDENT'

fail = (type, message) ->
	type: type
	error: true
	payload:
		error: message

success = (type, list) ->
	type: type
	payload: { list }

doAction = (method, body, doingActionType, didActionType, failureMessage, extra = {}) ->
	(dispatch, getState) ->
		dispatch { type: doingActionType }
		# We wrap with an extra promise, so that if there is a failure, no subsequent "then"'s will run after our catch block.
		new Promise (resolve, reject) ->
			fetchJson extra.url ? '/api/students',
				method: method,
				body: body
			.then (responseJson) ->
				if responseJson.status == 'success'
					dispatch doFlash('success', 'Success!', extra.successMessage) if extra.successMessage
					if extra.getSuccessPayload
						dispatch
							type: didActionType
							payload: extra.getSuccessPayload responseJson
					else
						dispatch success(didActionType, responseJson.data.list)
				else
					dispatch doFlash('error', 'Error!', responseJson.message)
					dispatch fail(didActionType, responseJson.message)
				resolve()
			, (error) ->
				dispatch doFlash('error', 'Error!', failureMessage)
				dispatch fail(didActionType, error.response['statusText'])
				reject error

doActionWithServerValidations = (method, body, doingActionType, didActionType, failureMessage, extra = {}) ->
	# Create and update validate the student on the backend, so this function returns validation errors
	# as part of the rejected promise if the API call fails.  The returned error is formatted to be usable
	# by redux-form to properly display errors.
	# This also doesn't show flash messages when the request fails, since redux-form handles notification that
	# there were errors.
	(dispatch, getState) ->
		dispatch { type: doingActionType }
		# We wrap with an extra promise, so that if there is a failure, no subsequent "then"'s will run after our catch block.
		new Promise (resolve, reject) ->
			fetchJson extra.url ? '/api/students',
				method: method,
				body: body
			.then (responseJson) ->
				if responseJson.status == 'success'
					dispatch doFlash('success', 'Success!', extra.successMessage) if extra.successMessage
					if extra.getSuccessPayload
						dispatch
							type: didActionType
							payload: extra.getSuccessPayload responseJson
					else
						dispatch success(didActionType, responseJson.data.list)
				else
					dispatch doFlash('error', 'Error!', responseJson.message)
					dispatch fail(didActionType, responseJson.message)
				resolve(responseJson.data)
			, (error) ->
				dispatch fail(didActionType, error.response['statusText'])
				reject error.response.json()


failFetchingStudents = (error) ->
	type: FETCHED_STUDENTS
	error: true
	payload:
		error: error

fetchedStudents = (students, pages) ->
	type: FETCHED_STUDENTS
	payload:
		students: students
		pages: pages

fetchingStudents = ->
	type: FETCHING_STUDENTS

module.exports = {
	AUTHENTICATED_STUDENT
	AUTHENTICATING_STUDENT

	LOG_STUDENT_OUT

	FAILED_CREATE_MESSAGE
	CREATED_STUDENT
	CREATING_STUDENT

	FAILED_DELETE_MESSAGE
	DELETED_STUDENT
	DELETING_STUDENT

	FAILED_FETCH_MESSAGE
	FETCHED_STUDENT
	FETCHING_STUDENT
	FETCHED_STUDENTS
	FETCHING_STUDENTS

	REMOVED_STUDENT_FROM_CLASSROOM
	REMOVING_STUDENT_FROM_CLASSROOM

	FAILED_UPDATE_MESSAGE
	UPDATED_STUDENT
	UPDATING_STUDENT

	authenticateStudent: (username, password, schoolId) ->
		method = 'post'
		payload = { username: username, password: password, school_id: schoolId }
		doingActionType = AUTHENTICATING_STUDENT
		didActionType = AUTHENTICATED_STUDENT
		failureMessage = null
		doActionWithServerValidations method, payload, doingActionType, didActionType, failureMessage,
			url: '/api/student_auth/login'
			getSuccessPayload: (responseJson) ->
				student: responseJson.data

	createStudent: (student) ->
		method = 'post'
		payload = student
		doingActionType = CREATING_STUDENT
		didActionType = CREATED_STUDENT
		failureMessage = null
		doActionWithServerValidations method, payload, doingActionType, didActionType, failureMessage,
			successMessage: SUCCEEDED_CREATE_MESSAGE
			getSuccessPayload: (responseJson) ->
				student: responseJson.data

	deleteStudent: (studentId) ->
		method = 'delete'
		payload = null
		doingActionType = DELETING_STUDENT
		didActionType = DELETED_STUDENT
		failureMessage = FAILED_DELETE_MESSAGE
		doAction method, payload, doingActionType, didActionType, failureMessage,
			successMessage: SUCCEEDED_DELETE_MESSAGE
			url: "/api/students/#{studentId}"
			getSuccessPayload: -> {}

	fetchStudent: (studentId) ->
		method = 'get'
		payload = null
		doingActionType = FETCHING_STUDENT
		didActionType = FETCHED_STUDENT
		failureMessage = FAILED_FETCH_SINGLE_MESSAGE
		doAction method, payload, doingActionType, didActionType, failureMessage,
			getSuccessPayload: (responseJson) ->
				student: responseJson.data.student
			url: "/api/students/#{studentId}"

	fetchStudents: (criteria) ->
		method = 'get'
		body = null
		doingActionType = FETCHING_STUDENTS
		didActionType = FETCHED_STUDENTS
		failureMessage = FAILED_FETCH_MESSAGE
		doAction method, body, doingActionType, didActionType, failureMessage,
			getSuccessPayload: (responseJson) ->
				list: responseJson.data.list
				pages: responseJson.data.pages
			url: '/api/students?' + serializeForQueryString(criteria)

	fetchUpdatedStudents: (criteria) ->
		method = 'get'
		body = null
		doingActionType = FETCHING_STUDENTS
		didActionType = FETCHED_STUDENTS
		failureMessage = FAILED_FETCH_MESSAGE
		doAction method, body, doingActionType, didActionType, failureMessage,
			getSuccessPayload: (responseJson) ->
				list: responseJson.data.list
				pages: responseJson.data.pages
			url: '/api/students/updated?' + serializeForQueryString(criteria)


	fetchStudentsBySchool: (schoolId) ->
		# Fetches all students for a school without pagination
		# This is really just a convenience method for `fetchStudents` above
		method = 'get'
		payload = null
		doingActionType = FETCHING_STUDENTS
		didActionType = FETCHED_STUDENTS
		failureMessage = FAILED_FETCH_MESSAGE
		doAction method, payload, doingActionType, didActionType, failureMessage,
			url: "/api/students?school_id=#{schoolId}"

	importBySchool: (data) ->
		method = 'post'
		payload = data
		doingActionType = IMPORTING_STUDENTS
		didActionType = IMPORTED_STUDENTS
		failureMessage = "Failed to import students"
		doAction method, payload, doingActionType, didActionType, failureMessage,
			successMessage: "Successfully imported students"
			getSuccessPayload: (responseJson) -> null
			url: '/api/students/by_school'

	removeStudentFromClassroom: (studentId, classroomId) ->
		method = 'post'
		payload = { student_id: studentId, classroom_id: classroomId }
		doingActionType = REMOVING_STUDENT_FROM_CLASSROOM
		didActionType = REMOVED_STUDENT_FROM_CLASSROOM
		failureMessage = FAILED_REMOVING_STUDENT
		doAction method, payload, doingActionType, didActionType, failureMessage,
			successMessage: SUCCEEDED_REMOVAL_MESSAGE
			url: '/api/students/remove_from_classroom'

	updateStudent: (student) ->
		method = 'PATCH'
		payload = student
		doingActionType = UPDATING_STUDENT
		didActionType = UPDATED_STUDENT
		failureMessage = null
		doActionWithServerValidations method, payload, doingActionType, didActionType, failureMessage,
			successMessage: SUCCEEDED_UPDATE_MESSAGE
			getSuccessPayload: (responseJson) ->
				student: responseJson.data
			url: "/api/students/#{student.id}"
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/students.coffee